import { render, staticRenderFns } from "./PasswordProtection.vue?vue&type=template&id=7b0c885e&"
import script from "./PasswordProtection.vue?vue&type=script&lang=ts&"
export * from "./PasswordProtection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports